import SimpleImageCarousel from '@homeaway/react-simple-image-carousel';
import React, {Component} from 'react';
import edap from '../../tripboard/edap';
import {getListingUrl} from './listing-url';

export class ListingMapCarousel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            imageIndex: 0,
            imageTotal: 0
        };
    }

    onCarouselHitClick = () => {
        const {
            detailPageUrl,
            target,
            onClick, // eslint-disable-line no-unused-vars
            stay
        } = this.props;

        const {dateRange} = stay || {};
        const {arrival, departure} = dateRange || {};
        const url = getListingUrl(detailPageUrl, arrival, departure);
        onClick();
        window.open(url, target);
    }

    onImageNavigateNext = (index) => {
        edap.carouselHitArrowClick('next');
        this.setState({imageIndex: index});
        this.props.updateCarouselState(this.state.imageIndex, this.state.imageTotal);
    };

    onImageNavigateBack = (index) => {
        edap.carouselHitArrowClick('back');
        this.setState({imageIndex: index});
        this.props.updateCarouselState(this.state.imageIndex, this.state.imageTotal);
    };

    render() {
        const lowResImages = this.props.images.map(({src: lowResSrc, lowResSrc: src, ...rest}) => ({src, lowResSrc, ...rest}));

        return (
            <SimpleImageCarousel
                images={lowResImages}
                index={this.state.imageIndex}
                transitionStyle="slide"
                transitionDuration={250}
                onNextClick={this.onImageNavigateNext}
                onPrevClick={this.onImageNavigateBack}
                onClick={this.onCarouselHitClick}
            />
        );
    }
}

export default ListingMapCarousel;


// WEBPACK FOOTER //
// ./src/universal/tripboard/listing/listing-map-carousel.js